import { render, staticRenderFns } from "./tipos_juegos_docente.vue?vue&type=template&id=4cd145b4"
import script from "./tipos_juegos_docente.vue?vue&type=script&lang=js"
export * from "./tipos_juegos_docente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports